export default __webpack_public_path__ + "static/media/Gloves of Vindictive Malice.4a6afe5e.jpg";